module.exports = __webpack_public_path__ + "static/media/plastic.7ad2db54.png";